import * as zod from 'zod';

export const GPUTaskRunnerState = zod.object({
  kind: zod.literal('GPUTaskRunner'),
  isRunningInference: zod.boolean(),
  isConfiguringInference: zod.boolean(),
  availableModels: zod.string().array(),
  isConnected: zod.boolean(),
});

export type GPUTaskRunnerState = zod.infer<typeof GPUTaskRunnerState>;
